module.exports = __webpack_public_path__ + "static/media/sj.ecbc9e93.svg";